export default {
      id: "ar-nature-usage",
      viewBox: "0 0 70 60",
      url: "../dist/images/" + "sprite.svg#ar-nature-usage",
      toString: function () {
        return this.url;
      }
    }